// extracted by mini-css-extract-plugin
export default {"vaildColor":"#44cc94","hr":"hr__2EJKJ","action":"action__2VmvB","headerconfirmation":"headerconfirmation__3SffK","headerTitleContainer":"headerTitleContainer__1FOP9","headerTitle":"headerTitle__BBqiR","contentContainer":"contentContainer__1YTMD","headerContainer":"headerContainer__1ZmRE","subHeaderContainer":"subHeaderContainer__3eARj","column":"column__2E-Rn"};
    if(module.hot) {
      // 1778491673667
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  